/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Route from 'solis/route';
import { useArg } from 'solis/navigation';
import Galaxy from 'solis/application/galaxy';
import Time from 'solis/time';

import GalaxyDiscovery from 'solis/claude/logic/galaxy/discovery';

import Args from 'solis/claude/action/args';
import AttackCard from 'solis/claude/card/attack';
import CreateBoard from 'solis/claude/action/view/create.board';


export default () =>
{
  const route = use(Route);
  const galaxy = use(Galaxy);
  const now = use(Time);

  const selected = useArg(Args.DeployBoard);

  const colony = galaxy.getColony(route.getArg('id'));
  const account = galaxy.getCurrentAccount();

  const entries = new GalaxyDiscovery(galaxy).getOpenBoardsByRemainingAuthority(account, now);

  const board = (entries.find(entry => entry.board.cass.id === selected) ?? entries[0])?.board ?? null;

  return (
    <Flex direction = 'column' gap = '4' p = '4'>
      <AttackCard board = {board} colony = {colony} />
      <CreateBoard context = {{ colony, account }} />
    </Flex>
  );
};
